<template>
  <div class="payment-result-page payment-success-page">
    <div class="result-container">
      <div class="success-icon">
        <div class="success-circle">
          <i class="el-icon-success"></i>
        </div>
      </div>
      
      <h1 class="result-title">支付成功</h1>
      <p class="result-subtitle">恭喜您，订阅已激活</p>
      
      <div class="order-info-card">
        <div class="info-row">
          <span class="label">订单编号</span>
          <span class="value">{{ orderInfo.order_no }}</span>
        </div>
        <div class="info-row">
          <span class="label">订阅方案</span>
          <span class="value">{{ orderInfo.plan_name || '-' }}</span>
        </div>
        <div class="info-row">
          <span class="label">订阅周期</span>
          <span class="value">{{ orderInfo.period || '-' }}</span>
        </div>
        <div class="info-row">
          <span class="label">支付金额</span>
          <span class="value amount">¥{{ orderInfo.amount }}</span>
        </div>
        <div class="info-row">
          <span class="label">支付方式</span>
          <span class="value">{{ getPaymentName(orderInfo.payment_method) }}</span>
        </div>
      </div>
      
      <div class="benefits-card">
        <h3>您的会员权益</h3>
        <div class="benefits-list">
          <div class="benefit-item">
            <i class="el-icon-check"></i>
            <span>{{ benefitsText }}</span>
          </div>
          <div class="benefit-item">
            <i class="el-icon-check"></i>
            <span>{{ planDetails.models_access === 'all' ? '全部模型支持' : '基础模型支持' }}</span>
          </div>
          <div class="benefit-item">
            <i class="el-icon-check"></i>
            <span>{{ planDetails.watermark ? '生成结果带水印' : '无水印' }}</span>
          </div>
          <div class="benefit-item" v-if="planDetails.api_access">
            <i class="el-icon-check"></i>
            <span>API 接口调用</span>
          </div>
        </div>
      </div>
      
      <div class="action-buttons">
        <button class="btn-secondary" @click="goToPrice">查看价格</button>
        <button class="btn-primary" @click="goToProfile">进入个人中心</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'PaymentSuccess',
  data() {
    return {
      orderInfo: {
        order_no: '',
        amount: 0,
        plan_name: '',
        period: '',
        payment_method: ''
      },
      planDetails: {
        models_access: 'basic',
        watermark: true,
        api_access: false
      },
      benefitsText: ''
    }
  },
  mounted() {
    this.loadOrderInfo()
  },
  methods: {
    async loadOrderInfo() {
      const orderNo = this.$route.query.order_no
      if (!orderNo) {
        this.$router.replace('/')
        return
      }
      
      try {
        const res = await axios.get(`/api/orders/${orderNo}`)
        if (res.data.code === 200) {
          this.orderInfo = res.data.data
          this.loadPlanDetails(res.data.data.plan_id)
        }
      } catch (err) {
        console.error('加载订单信息失败:', err)
      }
    },
    async loadPlanDetails(planId) {
      if (!planId) return
      try {
        const plans = JSON.parse(localStorage.getItem('subscription_plans') || '[]')
        const plan = plans.find(p => p.id === planId)
        if (plan) {
          this.planDetails = plan
          if (plan.monthly_quota === -1) {
            this.benefitsText = '无限次生成'
          } else if (plan.monthly_quota > 0) {
            this.benefitsText = `每月 ${plan.monthly_quota} 次生成`
          } else if (plan.daily_limit > 0) {
            this.benefitsText = `每天 ${plan.daily_limit} 次生成`
          }
        }
      } catch (err) {
        console.error('加载方案详情失败:', err)
      }
    },
    getPaymentName(method) {
      const names = { alipay: '支付宝', wechat: '微信支付', union: '银联支付' }
      return names[method] || method
    },
    goToPrice() {
      this.$router.push('/price')
    },
    goToProfile() {
      this.$router.push('/profile')
    }
  }
}
</script>

<style scoped>
.payment-result-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  background: #0a0f1a;
}

.result-container {
  max-width: 520px;
  width: 100%;
  text-align: center;
}

.success-icon {
  margin-bottom: 24px;
}

.success-circle {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(0, 230, 172, 0.2) 0%, rgba(0, 230, 172, 0.1) 100%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 40px;
  color: #00e6ac;
  border: 2px solid rgba(0, 230, 172, 0.3);
  animation: scaleIn 0.5s ease;
}

@keyframes scaleIn {
  from { transform: scale(0); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}

.result-title {
  font-size: 28px;
  font-weight: 700;
  color: #fff;
  margin: 0 0 8px;
}

.result-subtitle {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.5);
  margin: 0 0 32px;
}

.order-info-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 24px;
  text-align: left;
}

.info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.info-row:last-child {
  border-bottom: none;
}

.info-row .label {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
}

.info-row .value {
  font-size: 14px;
  color: #fff;
  font-weight: 500;
}

.info-row .value.amount {
  color: #00e6ac;
  font-size: 18px;
  font-weight: 700;
}

.benefits-card {
  background: rgba(0, 230, 172, 0.05);
  border: 1px solid rgba(0, 230, 172, 0.15);
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 32px;
  text-align: left;
}

.benefits-card h3 {
  font-size: 16px;
  font-weight: 600;
  color: #00e6ac;
  margin: 0 0 16px;
}

.benefits-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.benefit-item {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.8);
}

.benefit-item i {
  color: #00e6ac;
  font-size: 16px;
  flex-shrink: 0;
}

.action-buttons {
  display: flex;
  gap: 16px;
  justify-content: center;
}

.btn-primary, .btn-secondary {
  padding: 14px 32px;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
}

.btn-primary {
  background: linear-gradient(135deg, #00e6ac, #00cc99);
  color: #0a0f1a;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0, 230, 172, 0.3);
}

.btn-secondary {
  background: rgba(255, 255, 255, 0.05);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.btn-secondary:hover {
  background: rgba(255, 255, 255, 0.1);
}
</style>
